import React from "react";
// Import Ant Design opsional (dibiarkan sesuai permintaan)
import { Typography, List } from "antd";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <>
      {/* Style ditempatkan di sini */}
      <style>{`
        .privacy-page-wrapper {
          margin: 0;
          padding: 0;
          background: #ffffff;
          font-family: Arial, Helvetica, sans-serif;
          color: #000;
        }
        .container {
          max-width: 800px;
          margin: 0 auto;
          padding: 40px;
          font-size: 14px;
          line-height: 1.7;
        }
        .privacy-page-wrapper h1 {
          font-size: 24px;
          text-align: center;
          font-weight: bold;
          margin-bottom: 6px;
        }
        .privacy-page-wrapper h2 {
          font-size: 18px;
          margin-top: 32px;
          margin-bottom: 10px;
          font-weight: bold;
          text-decoration: underline;
        }
        .privacy-page-wrapper h3 {
          font-size: 15px;
          font-weight: bold;
          margin-top: 22px;
        }
        .privacy-page-wrapper p {
          text-align: justify;
          margin: 8px 0;
        }
        .privacy-page-wrapper ul {
          margin-left: 20px;
        }
        .privacy-page-wrapper li {
          margin-bottom: 6px;
          text-align: justify;
        }
        .effective-date {
          text-align: center;
          font-size: 16px;
          margin-bottom: 24px;
        }
      `}</style>

      {/* Wrapper utama */}
      <div className="privacy-page-wrapper">
        <div className="container">
          <h1> KEBIJAKAN PRIVASI DESAPEDIA </h1>
          <h1 style={{ fontSize: "20px" }}> PEMBERITAHUAN PRIVASI </h1>
          <div className="effective-date"> Berlaku mulai 20 Januari 2025 </div>

          <h2> PENGANTAR </h2>
          <p>
            Pemberitahuan Privasi ini menjelaskan bagaimana PT Agriva Teknologi
            Nusantara beserta afiliasinya (<strong> “Desapedia” </strong>)
            mengumpulkan, memperoleh, menyimpan, menggunakan, mengelola,
            memproses, menganalisis, mengungkapkan, serta melindungi Data
            Pribadi Anda sesuai dengan peraturan perundang-undangan yang berlaku
            di Indonesia.
          </p>

          <p>
            Kebijakan Privasi ini berlaku untuk seluruh pengguna dan/atau
            penyedia layanan yang mengakses dan menggunakan aplikasi{" "}
            <strong> Desapedia </strong>, aplikasi <strong> Gaspol </strong>{" "}
            (yang secara fungsional merupakan aplikasi{" "}
            <strong> Gaspol Customer </strong>), serta aplikasi{" "}
            <strong> Gaspol Driver </strong>, termasuk seluruh fitur, layanan,
            dan produk yang disediakan melalui platform Desapedia (secara
            kolektif disebut <strong> “Aplikasi” </strong>).
          </p>

          <p>
            Aplikasi <strong> Gaspol </strong> (nama yang ditampilkan di Google
            Play Store dan Apple App Store) digunakan oleh pengguna untuk
            mengakses layanan berbasis permintaan (on-demand), termasuk layanan
            transportasi kendaraan bermotor, pengiriman barang atau paket, serta
            pengantaran makanan dari mitra merchant.
          </p>

          <p>
            Aplikasi <strong> Gaspol Driver </strong> digunakan oleh mitra
            pengemudi (driver) untuk menerima, menjalankan, dan menyelesaikan
            pesanan layanan yang diajukan oleh pengguna melalui platform
            Desapedia.
          </p>

          <h2> 1. JENIS DATA PRIBADI YANG KAMI KUMPULKAN </h2>
          <p> Kami dapat mengumpulkan Data Pribadi berikut: </p>
          <ul>
            <li> Data identitas (nama, NIK, foto, tanggal lahir); </li>
            <li> Data kontak (alamat, nomor telepon, alamat email); </li>
            <li> Data akun dan autentikasi; </li>
            <li> Data transaksi dan riwayat layanan; </li>
            <li> Data keuangan dan pembayaran; </li>
            <li> Data perangkat, teknis, dan log sistem; </li>
            <li> Data lokasi geografis, termasuk lokasi real-time. </li>
          </ul>

          <h2> 2. CARA KAMI MENGUMPULKAN DATA PRIBADI </h2>
          <p>
            Data Pribadi dikumpulkan secara langsung dari Anda, secara otomatis
            saat Anda menggunakan Aplikasi, atau dari pihak ketiga yang bekerja
            sama dengan Kami sesuai dengan ketentuan hukum yang berlaku.
          </p>

          <h2> 3. PENGGUNAAN DATA PRIBADI </h2>
          <p> Data Pribadi digunakan untuk tujuan sebagai berikut: </p>
          <ul>
            <li> Menyediakan dan mengelola layanan Aplikasi; </li>
            <li>
              {" "}
              Menghubungkan pengguna dengan mitra pengemudi dan merchant;{" "}
            </li>
            <li> Memproses pesanan, transaksi, dan pembayaran; </li>
            <li> Menyediakan estimasi biaya, jarak, dan waktu; </li>
            <li> Keamanan, pencegahan penipuan, dan penyelesaian sengketa; </li>
            <li> Pengembangan, analisis, dan peningkatan layanan. </li>
          </ul>

          <p>
            <strong> Data lokasi </strong> hanya digunakan selama layanan
            berlangsung atau sesuai kebutuhan operasional untuk penyediaan
            layanan, dan tidak digunakan untuk tujuan lain di luar layanan tanpa
            persetujuan eksplisit dari Anda.
          </p>

          <h2> 4. PENGUNGKAPAN DATA PRIBADI </h2>
          <p>
            {" "}
            Kami dapat membagikan Data Pribadi Anda secara terbatas kepada:{" "}
          </p>
          <ul>
            <li> Mitra pengemudi (driver) untuk pelaksanaan layanan; </li>
            <li> Mitra merchant untuk pemrosesan pesanan; </li>
            <li> Penyedia pembayaran dan mitra teknologi; </li>
            <li> Instansi pemerintah atau pihak berwenang sesuai hukum. </li>
          </ul>

          <p>
            Kami menegaskan bahwa Kami{" "}
            <strong> tidak menjual atau menyewakan </strong>
            Data Pribadi Anda kepada pihak mana pun.
          </p>

          <h2> 5. RETENSI DATA </h2>
          <p>
            Data Pribadi disimpan selama diperlukan untuk mencapai tujuan
            pengumpulannya atau selama diwajibkan oleh peraturan
            perundang-undangan yang berlaku. Setelah itu, data akan dihapus atau
            dianonimkan.
          </p>

          <h2> 6. KEAMANAN DATA </h2>
          <p>
            Kami menerapkan langkah-langkah teknis dan organisasi yang wajar
            untuk melindungi Data Pribadi Anda dari akses tidak sah, kehilangan,
            perubahan, atau penyalahgunaan.
          </p>

          <h2> 7. HAK ANDA </h2>
          <p> Anda memiliki hak sesuai hukum yang berlaku untuk: </p>
          <ul>
            <li> Mengakses dan memperbaiki Data Pribadi; </li>
            <li> Menarik persetujuan pemrosesan data; </li>
            <li> Mengajukan keberatan atas pemrosesan tertentu; </li>
            <li> Meminta penghapusan Data Pribadi dan akun. </li>
          </ul>

          <h2> 8. PENGHAPUSAN AKUN </h2>
          <p>
            Pengguna dapat mengajukan penghapusan akun melalui fitur yang
            tersedia di dalam Aplikasi. Apabila mengalami kendala, permintaan
            penghapusan akun dapat diajukan melalui halaman resmi Kebijakan
            Privasi Desapedia.
          </p>

          <h2> 9. PERUBAHAN KEBIJAKAN PRIVASI </h2>
          <p>
            Kami dapat meninjau dan memperbarui Kebijakan Privasi ini dari waktu
            ke waktu. Perubahan akan diberitahukan melalui Aplikasi atau saluran
            resmi Kami dan berlaku sejak tanggal ditetapkan.
          </p>

          <h2> 10. CARA MENGHUBUNGI KAMI </h2>
          <p>
            PT Agriva Teknologi Nusantara
            <br />
            Data Protection & Privacy Office
            <br />
            Jl. Durian I No. 30 Blok D3 – Vida Bumi Pala
            <br />
            Kota Bekasi, Jawa Barat 17156
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
